/**
 * Smithing table screen (vanilla SmithingScreen 176x166): template (8,48),
 * base (26,48), addition (44,48), result (98,48). Taking the result uses one
 * of each input.
 */

import { smithingMenu } from '../../game/menu';
import { GuiStage, sheet } from '../kit';
import { ContainerScreen } from './container';
import { attachRecipeList } from './recipeBook';
import { smithingRows } from '../../game/recipeBook';
import { nameOf } from '../../items';
import type { ScreenDeps } from './screenHost';

export class SmithingScreen extends ContainerScreen {
  constructor(deps: ScreenDeps, stage: GuiStage) {
    super(deps, stage);
    this.root.appendChild(sheet('gui/container/smithing.png', 0, 0, 176, 166, 0, 0));
    // 0 template, 1 base, 2 addition, 3 result, 4..30 main, 31..39 hotbar
    this.use(smithingMenu(this.env()));
    this.at(0, 8, 48, { emptyIcon: 'gui/sprites/container/slot/smithing_template_netherite_upgrade.png' });
    this.at(1, 26, 48);
    this.at(2, 44, 48, { emptyIcon: 'gui/sprites/container/slot/ingot.png' });
    this.at(3, 98, 48);
    this.placePlayer(4, 84, 142);
    this.addLabel('Upgrade Gear', 44, 15);
    this.addLabel('Inventory', 8, 72);
    attachRecipeList(this, { x: 150, y: 6 }, 'Upgrades', smithingRows(),
      (r) => [`${nameOf(r.inputs[1].id)} + Netherite Ingot`, `\u00a77+ Netherite Upgrade Template = ${nameOf(r.output.id)}`]);
    this.mount();
  }
}
